import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface ReportSnackbarData {
  message: string;
  url: string;
}

@Component({
  selector: 'app-report-snackbar',
  templateUrl: './report-snackbar.component.html',
  styleUrls: ['./report-snackbar.component.scss'],
})
export class ReportSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ReportSnackbarData,
    private snackBarRef: MatSnackBarRef<ReportSnackbarComponent>
  ) {}

  viewReport(): void {
    window.open(this.data.url, '_blank');
    this.snackBarRef.dismissWithAction();
  }

  dismiss(): void {
    this.snackBarRef.dismissWithAction();
  }
}
